//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      hovered: false,
      hoveredTimeout: null,
      hoverStyles: {
        width: '282px',
        height: '80px',
        left: 0,
        top: 0
      }
    };
  },
  props: {
    menu: {
      type: Object,
      required: true
    }
  },
  methods: {
    onHover(index, $event) {
      if (this.menu.label === 'Partners') return;

      clearTimeout(this.hoveredTimeout);
      this.hovered = true;
      const self = this;
      const $elem = $event.target;
      const $parent = $elem.closest('.menu-box');

      const padding = { x: 32, y: 16 };

      self.hoverStyles.width = $elem.clientWidth + padding.x / 2 + 'px';
      self.hoverStyles.height =
        'calc(' + ($elem.clientHeight + padding.y) + 'px)';
      self.hoverStyles.left =
        $elem.offsetLeft - padding.x / 2 + $parent.offsetLeft + 'px';
      self.hoverStyles.top =
        'calc(' + ($elem.offsetTop - padding.y / 2) + 'px)';
    },
    onLeave($event) {
      const self = this;

      clearTimeout(self.hoveredTimeout);

      self.hoveredTimeout = setTimeout(function() {
        self.hovered = false;
      }, 200);
    }
  }
};
